import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'
import Typography from '../../Typography/Typography'
import Icon from '../../Icon/Icon'

import './FormPasswordValidation.scss'

const getValidationClass = (touched, validated, isTypography) => {
    if (!touched) {
        return isTypography ? 'lighterPrimary' : 'neutral'
    }

    if (validated) {
        return isTypography ? 'primary' : 'success'
    }

    return 'error'
}

const FormPasswordValidation = ({ value, touched, email }) => {
    const intl = useIntl()

    const passwordValidations = [
        {
            text: intl.formatMessage({ id: 'forms.passwordValidation.length' }),
            validation: value?.match(/^(.{8,16})$/),
        },
        {
            text: intl.formatMessage({ id: 'forms.passwordValidation.letter' }),
            validation: value?.match(/[a-z,A-Z]/),
        },
        {
            text: intl.formatMessage({ id: 'forms.passwordValidation.number' }),
            validation: value?.match(/\d/),
        },
        {
            text: intl.formatMessage({ id: 'forms.passwordValidation.email' }),
            validation: value !== email,
        },
    ]

    return (
        <Container fluid className={'form-password-validation d-flex flex-column gap-1'}>
            {passwordValidations.map(({ text, validation }) => (
                <div key={text} className={'d-flex align-items-center'}>
                    <Icon className={'me-2'} name={`validation-${getValidationClass(touched, validation, false)}`} />
                    <Typography variant={'formDescription'} color={getValidationClass(touched, validation, true)}>
                        {text}
                    </Typography>
                </div>
            ))}
        </Container>
    )
}

export default FormPasswordValidation
